import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BoundaryCreateSubmitModalContainer, type BoundaryCreateSubmitModalProps,
} from './boundaryCreateSubmitModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryCreateSubmit: BoundaryCreateSubmitModalProps;
  }
}
modalRenderer.register('BoundaryCreateSubmit', BoundaryCreateSubmitModalContainer);
